import type { ReactNode } from "react";
import { DismissRegular } from "@fluentui/react-icons";
import styles from "./NewRequestDialog.module.scss";

interface IDialogHeaderProps {
  title: string;
  titleId?: string;
  onClose: () => void;
}

export function DialogHeader({ title, titleId, onClose }: IDialogHeaderProps): ReactNode {
  return (
    <div className={styles.header}>
      <h2 id={titleId} className={styles.headerText}>{title}</h2>
      <button
        type="button"
        className={styles.closeButton}
        onClick={onClose}
        aria-label="Close dialog"
      >
        <DismissRegular />
      </button>
    </div>
  );
}
